import { toast } from "react-toastify";
import CheckCircleSharpIcon from "@mui/icons-material/CheckCircleSharp";
import CancelSharpIcon from "@mui/icons-material/CancelSharp";
import InfoIcon from '@mui/icons-material/Info';
import './CustomToaster.css'

export function ToastSuccess({ message, icon = false }) {
  toast.success(
    <span className="toaster" style={{color:" #fff !important"}}>
      {message}{" "}
      <CheckCircleSharpIcon
        style={{ verticalAlign: "middle", color: "green" }}
      />
    </span>,
    {
      className: "custom-toast",
      icon: icon,
    }
  );
}

export function ToastInfo({ message, icon = false }) {
  toast.info(
    <span className="toaster" style={{color:" #fff !important"}}>
      {message}{" "}
      <InfoIcon
        style={{ verticalAlign: "middle", color: "#3498db" }}
      />
    </span>,
    {
      className: "custom-toast",
      icon: icon,
    }
  );
}

export function ToastError({ message, icon = false }) {
  toast.error(
    <span className="toaster" style={{color:" #fff !important"}}>
      {message}{" "}
      <CancelSharpIcon style={{ verticalAlign: "middle", color: "red" }} />
    </span>,
    {
      className: "custom-toast",
      icon: icon,
    }
  );
}
